"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurTeam() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const drivers = [{
    name: "Michael Torres",
    credentials: "Senior Chauffeur • 12 Years Experience",
    image: "/img/michael_torres_professional_chauffeur.png"
  }, {
    name: "David Chen",
    credentials: "Executive Driver • 8 Years Experience",
    image: "/img/david_chen_executive_transport.png"
  }, {
    name: "James Rodriguez",
    credentials: "VIP Chauffeur • 10 Years Experience",
    image: "/img/james_rodriguez_vip_driver.png"
  }];
  return <section id="our-team" className="dark bg-background text-foreground section-padding px-4">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Our Team
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Meet our professional chauffeurs dedicated to your comfort and safety
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div ref={card1Ref} className="group" style={{
          opacity: card1Visible ? 1 : 0,
          transform: card1Visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out",
          transitionDelay: "0ms"
        }}>
            <Card className="glass-effect overflow-hidden border-white/10 hover:scale-[1.02] transition-all duration-[var(--duration-medium)]">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/michael_torres_chauffeur.png" alt={drivers[0].name} className="h-full w-full object-cover grayscale contrast-125 group-hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/90 via-primary-dark/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-[var(--duration-medium)]" />
                <div className="absolute bottom-0 left-0 right-0 translate-y-2 p-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[var(--duration-medium)]">
                  <h3 className="font-display text-2xl font-bold text-white">
                    {drivers[0].name}
                  </h3>
                  <p className="mt-1 text-sm text-white/80">
                    {drivers[0].credentials}
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <div ref={card2Ref} className="group" style={{
          opacity: card2Visible ? 1 : 0,
          transform: card2Visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out",
          transitionDelay: "100ms"
        }}>
            <Card className="glass-effect overflow-hidden border-white/10 hover:scale-[1.02] transition-all duration-[var(--duration-medium)]">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src="https://humane-alien.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-02-17-133500.png" alt={drivers[1].name} className="h-full w-full object-cover grayscale contrast-125 group-hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/90 via-primary-dark/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-[var(--duration-medium)]" />
                <div className="absolute bottom-0 left-0 right-0 translate-y-2 p-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[var(--duration-medium)]">
                  <h3 className="font-display text-2xl font-bold text-white">
                    {drivers[1].name}
                  </h3>
                  <p className="mt-1 text-sm text-white/80">
                    {drivers[1].credentials}
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <div ref={card3Ref} className="group" style={{
          opacity: card3Visible ? 1 : 0,
          transform: card3Visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out",
          transitionDelay: "200ms"
        }}>
            <Card className="glass-effect overflow-hidden border-white/10 hover:scale-[1.02] transition-all duration-[var(--duration-medium)]">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/david_chen_executive_driver.png" alt={drivers[2].name} className="h-full w-full object-cover grayscale contrast-125 group-hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/90 via-primary-dark/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-[var(--duration-medium)]" />
                <div className="absolute bottom-0 left-0 right-0 translate-y-2 p-6 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[var(--duration-medium)]">
                  <h3 className="font-display text-2xl font-bold text-white">
                    {drivers[2].name}
                  </h3>
                  <p className="mt-1 text-sm text-white/80">
                    {drivers[2].credentials}
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}